<template>
  <div data-v-63c64df2="" data-v-2ac6a5fc="" class="deposit-container">
    <div v-if="xieshow" data-v-26c8fc86="" data-v-71669d2d="" class="protocolPopUp">
      <div data-v-26c8fc86="" class="title">
        协议区别
        <div data-v-26c8fc86="" @click="openXie" class="close"></div>
      </div>
      <div data-v-26c8fc86="" class="content"><img data-v-26c8fc86="" src="/static/image/protocol.5fb87878.jpg" alt="" /></div>
    </div>

    <div data-v-63c64df2="" class="cardgroup">
      <div data-v-63c64df2="" class="channels">
        <div data-v-63c64df2="" @click="changTab(0)" :class="tab == 0 ? 'channel active' : 'channel'" v-if="payWayList.usdt == 1">
          <div data-v-63c64df2="" class="title">数字货币</div>
          <div data-v-63c64df2="" class="border"></div>
        </div>
        <div data-v-63c64df2="" @click="changTab(1)" :class="tab == 1 ? 'channel active' : 'channel'" v-if="payWayList.card == 1 || payWayList.alipay == 1 || payWayList.wechat == 1">
          <div data-v-63c64df2="" class="title">人民币</div>
          <div data-v-63c64df2="" class="border"></div>
        </div>
      </div>
    </div>
    <div data-v-71669d2d="" data-v-643ab01c="" class="deposit" v-if="tab == 0">
      <div data-v-71669d2d="">
        <div data-v-71669d2d="" class="deposit__content">
          <p data-v-71669d2d="" class="deposit__title">方式</p>
          <ul data-v-71669d2d="" class="deposit__list">
            <li data-v-71669d2d="" class="deposit__item active">
              <!-- <img
                data-v-71669d2d=""
                src="data:image/png;base64,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"
                alt=""
                class="deposit__icon"
              /> -->
              <img data-v-71669d2d="" src="/static/image/usdt.png" alt="" class="deposit__icon" />

              <p data-v-71669d2d="">虚拟币转账</p>
            </li>
            <!-- <li data-v-71669d2d="" class="deposit__item">
              <img data-v-71669d2d="" src="/static/image/usdt.png" alt="" class="deposit__icon" />
              <p data-v-71669d2d="">小金库钱包</p>
            </li> -->
          </ul>
          <div data-v-71669d2d="" class="protocol-box">
            <p data-v-71669d2d="" class="sub-tips">钱包协议 <img data-v-71669d2d="" @click="openXie" style="width: 18px; height: 18px" src="/static/image/question.a2204a13.svg" alt="" /></p>
            <div data-v-71669d2d="" class="dcbox-protocol">
              <div data-v-71669d2d="" :class="meyXi == 'TRC20' ? 'protocol-item active' : 'protocol-item'" @click="changMeyXi('TRC20')">
                <span data-v-71669d2d="" class="circle"></span><span data-v-71669d2d="" class="text">TRC20</span><img data-v-71669d2d="" src="/static/image/recommend1.54a3b035.png" alt="" />
              </div>
              <div data-v-71669d2d="" :class="meyXi == 'ERC20' ? 'protocol-item active' : 'protocol-item'" @click="changMeyXi('ERC20')"><span data-v-71669d2d="" class="circle"></span><span data-v-71669d2d="" class="text">ERC20</span></div>
            </div>
          </div>
          <div data-v-71669d2d="" class="deposit-input">
            <p data-v-71669d2d="" class="deposit-input-title" style="font-size: 16px; color: #fff; padding: 15px 0">金额</p>
            <div data-v-71669d2d="" class="deposit__amount-input-wrapper" style="height: 40px">
              <input data-v-71669d2d="" id="amount1" v-model="amount" :placeholder="`请输入取款金额 ${min_price} - ${max_price}`" type="text" class="deposit__amount-input" /><span data-v-71669d2d="" style="height: 100%; padding: 0 12px" class="deposit__amount-unit">CNY</span>
            </div>
          </div>
          <p data-v-71669d2d="" class="deposit__cny-tips" style="margin-top: 10px">≈{{ amount ? Math.floor((amount / $store.state.userInfo.usdtrate) * 100) / 100 : '0.00' }}USDT &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;参考汇率：{{ $store.state.userInfo.usdtrate }}</p>
          <button data-v-71669d2d="" class="deposit__button" @click="usdtchongBi">确定</button>
        </div>
      </div>
      <div data-v-5742baa6="" data-v-71669d2d="" class="dialog">
        <div data-v-5742baa6="" class="dialog-cover back" style="display: none"></div>
        <div data-v-5742baa6="" class="dialog-content" style="display: none">
          <div data-v-71669d2d="" class="side">
            <div data-v-71669d2d="" class="side">
              <div data-v-71669d2d="" class="side__header"><span data-v-71669d2d="">银联充币</span><a data-v-71669d2d="" href="javascript:void 0;" class="side__close"></a></div>
              <div data-v-71669d2d="" class="side__content"><ul data-v-71669d2d="" class="exchange"></ul></div>
            </div>
          </div>
        </div>
      </div>
      <div data-v-5742baa6="" data-v-71669d2d="" class="dialog" v-if="ustShow">
        <div data-v-5742baa6="" class="dialog-cover back"></div>
        <div data-v-5742baa6="" class="dialog-content">
          <div data-v-71669d2d="" class="side">
            <div data-v-71669d2d="" class="side__header"><span data-v-71669d2d="">虚拟币存款</span><a data-v-71669d2d="" href="javascript:void 0;" @click="closeUstShow" class="side__close"></a></div>
            <div data-v-71669d2d="" class="side__content">
              <div data-v-71669d2d="" class="scan">
                <div data-v-71669d2d="" class="scan__amount">
                  <span data-v-71669d2d=""> 存款金额 </span><span data-v-71669d2d="" class="scan__amount-number"> {{ payInfo.info.amount }}CNY</span>
                </div>
                <div data-v-71669d2d="" class="scan__amount">
                  <span data-v-71669d2d="">预计到账</span><span data-v-71669d2d="" class="scan__amount-number">{{ payInfo.info.real_money }} USDT</span>
                </div>
                <p data-v-71669d2d="" class="scan__title">使用钱包APP扫描二维码完成付款</p>
                <p data-v-71669d2d="" class="scan__subtitle">可先截屏保存至相册，再使用钱包扫码转账</p>
                <!-- <p data-v-71669d2d="" class="scan__crc">470383C8</p>
                <div data-v-71669d2d="" class="scan__qrwrap"><p data-v-71669d2d="" class="crc2">470383C8</p></div> -->
                <div data-v-71669d2d="" id="scanQr" class="scan__qr" :title="payInfo.cardlist.mch_id">
                  <img alt="Scan me!" :src="payInfo.cardlist.payimg" style="display: block" />
                </div>
                <div data-v-71669d2d="" class="scan__protocol">
                  {{ payInfo.info.bank }}协议
                  <!-- <span data-v-71669d2d="" class="ex-change">
                    切换
                    <img
                      data-v-71669d2d=""
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAjVBMVEUAAAD/zE3/y0z/zE3/y03/zE3/42H/zEz/zEz/zEz/zEz/zE3/zE3/zU3/z0//3Fz/zE3/zE3/zE3/zE3/z07/z0//zlL/zEz/zE3/zE3/zU3/z0//z1H/zEz/zE3/zUz/zEz/zE3/zEz/11L/////zE3/zEz/zk7/2lX/zU3/y03/zk3/zU//y07/y0yJza/CAAAALnRSTlMA9PiBhbgE8Pzq5qqkRTEIysKwTi0oGuKPaVofFdqdlId2cBIB3tQ5DXpnUz07fusvKAAAAUVJREFUWMPt2Mlyg0AMBNDGDuABDDarbfC+ZtP/f17iVIJ88UXSKcX7gD5MFT3T4Jk2iVxSQ20a0jfXQWk5oR8LqAQL+jWDxs2nPzkU2gv1CshdHd2pj2g16mMmS4idxtQLpxDLYs5ZVxCrZ5wzP0IsbThnE0Cs8PiY95DbU88rIBZsOKdJIXacc86shli15pw4U5VPb3xSl8/daKU45i0xfyxxuN5zfDIQB3ghE2NEZOIMj0yE8MmEj9QjA14JpLkbKbm4wmAwGAyeq2LnKUV5CZQ25Z/aXUeh1QXZkInI6hGxQ5CTAT8D8LF/kfCJbQOIrR6e9wfIWa2ohHPOJcS6xxXVQaxsOCfJTFYUvULuMOFP9d1mRUX/dEXtThB7U60otqOe+4RcwTmXFgo5l88NGnNd+bAF/8LR6SIuH506cVHS4okv8K7j0X+jD5gAAAAASUVORK5CYII="
                  /></span> -->
                </div>
                <div data-v-71669d2d="" class="scan__link">
                  <span data-v-71669d2d="">{{ payInfo.cardlist.mch_id }}</span
                  ><a data-v-71669d2d="" data-clipboard-text="TKg3tteUyTj6yZiLE2LBiNKSt5yXM9eSNU" @click="doCopy(payInfo.cardlist.mch_id)" href="javascript:void 0;" class="scan__copy">复制</a>
                </div>
                <p data-v-71669d2d="" class="scan__tips">*请选择正确的钱包协议类型进行存款,否则资产将无法找回</p>
                <button data-v-71669d2d="" class="scan__button" @click="closeUstShow1">已完成支付</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div data-v-71669d2d="" class="kyberbit-guide-button" style="display: none"></div>
      <div data-v-a795a268="" data-v-71669d2d="" class="backdrop2" style="display: none">
        <div data-v-a795a268="" class="popSlider">
          <span data-v-a795a268="" class="close"></span>
          <div data-v-a795a268="" class="slider">
            <div data-v-a795a268="" class="swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-autoheight swiper-container-ios">
              <div class="swiper-wrapper" style="transition-duration: 0ms">
                <div data-v-a795a268="" class="item swiper-slide">
                  <div data-v-a795a268="" class="bg6">
                    <div data-v-a795a268="" class="title-c-f"><div data-v-a795a268="" class="title">第一步：选择添加小金库方式（有小金库账户，只需把小金库App“我的”里小金库号填上；没有账户则一键注册绑定小金库）</div></div>
                  </div>
                </div>
                <div data-v-a795a268="" class="item swiper-slide">
                  <div data-v-a795a268="" class="bg7">
                    <div data-v-a795a268="" class="title-c"><div data-v-a795a268="" class="title">第二步：提示绑定成功，扫描旁边二维码下载安装，方便下次使用。</div></div>
                  </div>
                </div>
                <div data-v-a795a268="" class="item swiper-slide">
                  <div data-v-a795a268="" class="bg8">
                    <div data-v-a795a268="" class="title-c"><div data-v-a795a268="" class="title">第三步：进入小金库首页，点击图1右上角【APP】&gt;再选择图2所列版本进行下载安装。</div></div>
                  </div>
                </div>
                <div data-v-a795a268="" class="item swiper-slide">
                  <div data-v-a795a268="" class="bg9">
                    <div data-v-a795a268="" class="title-c"><div data-v-a795a268="" class="title">第四步：安装成功，打开小金库app，进入首页即可对账户内金额进行存取。</div></div>
                  </div>
                </div>
              </div>
              <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
            </div>
            <div data-v-a795a268="" slot="button-next" class="swiper-button-next" tabindex="0" role="button" aria-label="Next slide" aria-disabled="false"></div>
            <div data-v-a795a268="" slot="button-prev" class="swiper-button-prev" tabindex="0" role="button" aria-label="Previous slide" aria-disabled="false"></div>
            <div data-v-a795a268="" slot="pagination" class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets"></div>
            <div data-v-a795a268="" class="popButtons">
              <div data-v-a795a268="" class="btn1">小金库教程</div>
              <div data-v-a795a268="" class="btn2">下载小金库</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div data-v-a3842dac="" data-v-63c64df2="" class="deposit" v-if="tab == 1">
      <div data-v-a3842dac="" class="low-special">
        <div data-v-a3842dac="" class="deposit-title">方式</div>

        <div data-v-a3842dac="">
          <div data-v-a3842dac="">
            <div data-v-a3842dac="" @click="changPayway(1)" v-if="payWayList.card == 1" :class="pay_way == 1 ? 'deposit-bq yesBorder' : 'deposit-bq noBorder'">
              <div data-v-a3842dac="" class="deposit-item active">
                <div data-v-a3842dac="" class="deposit-info">
                  <span data-v-a3842dac="" class="icon icon-unionpay"></span
                  ><span data-v-a3842dac="">
                    银联支付<br data-v-a3842dac="" />
                    <span data-v-a3842dac="" class="subText">安全极速到账,存款无忧</span></span
                  >
                </div>
                <div data-v-a3842dac="" class="recommend"></div>
              </div>
            </div>
            <div data-v-a3842dac="" @click="changPayway(2)" :class="pay_way == 2 ? 'deposit-bq yesBorder' : 'deposit-bq noBorder'" v-if="payWayList.alipay == 1">
              <div data-v-a3842dac="" class="deposit-item">
                <div data-v-a3842dac="" class="deposit-info">
                  <span data-v-a3842dac="" class="icon icon-alipay"></span
                  ><span data-v-a3842dac="">
                    支付宝支付<br data-v-a3842dac="" />
                    <span data-v-a3842dac="" class="subText"></span
                  ></span>
                </div>
              </div>
            </div>
          </div>
          <div data-v-a3842dac="" @click="changPayway(3)" :class="pay_way == 3 ? 'deposit-bq yesBorder' : 'deposit-bq noBorder'" v-if="payWayList.wechat == 1">
            <div data-v-a3842dac="" class="deposit-item">
              <div data-v-a3842dac="" class="deposit-info">
                <span data-v-a3842dac="" class="icon icon-wechat"></span
                ><span data-v-a3842dac="">
                  微信支付<br data-v-a3842dac="" />
                  <span data-v-a3842dac="" class="subText"></span
                ></span>
              </div>
            </div>
          </div>
        </div>
        <div class="JoiHTIGs" v-if="pay_way == 1 && !(userbank.length == 0 && userUSD.length == 0)">
          <div class="_1lgxzaTd VnPYo1MB _3jiVkBQ9" v-for="(item, index) in cardLis" :key="index">
            <p style="font-size: 10px; line-height: 1; color: #fff; line-height: 1.5">收款银行：{{ item.bank_data.bank_name }}</p>
            <p style="font-size: 10px; line-height: 1; color: #fff; line-height: 1.5">账号：{{ item.bank_no }} <img @click="doCopy(item.bank_no)" style="width: 20px; float: right" src="/static/image/clongicon.png" alt="" /></p>
            <p style="font-size: 10px; line-height: 1; color: #fff; line-height: 1.5">户名：{{ item.bank_owner }} <img @click="doCopy(item.bank_owner)" style="width: 20px; float: right" src="/static/image/clongicon.png" alt="" /></p>
            <p style="font-size: 10px; line-height: 1.2; color: #fff; line-height: 1.5">银行地址：{{ item.bank_address }}</p>
          </div>
        </div>
        <div data-v-a3842dac="" class="deposit-title" v-if="pay_way == 1">汇款姓名</div>
        <div data-v-a3842dac="" class="amount-wrap" v-if="pay_way == 1">
          <input data-v-a3842dac="" placeholder="请输入汇款姓名" v-model="bankBox.bank_owner" type="text" maxlength="17" class="amount-input" />
        </div>
        <div data-v-a3842dac="" class="deposit-title" v-if="pay_way == 1">银行类型</div>
        <div data-v-a3842dac="" class="amount-wrap" v-if="pay_way == 1">
          <el-select v-model="bankBox.bank" placeholder="请选择银行类型" class="amount-input" style="background: #212121; width: 100%">
            <el-option v-for="(item, index) in banklist" :key="index" :label="item.bank_name" :value="item.bank_name"> </el-option>
          </el-select>
        </div>
        <div data-v-a3842dac="" class="deposit-title" v-if="pay_way == 1">汇款卡号</div>
        <div data-v-a3842dac="" class="amount-wrap" v-if="pay_way == 1">
          <input data-v-a3842dac="" placeholder="请输入汇款卡号" v-model="bankBox.bank_no" type="text" maxlength="20" class="amount-input" />
        </div>
        <div data-v-a3842dac="" class="deposit-title" v-if="pay_way == 1">开户行</div>
        <div data-v-a3842dac="" class="amount-wrap" v-if="pay_way == 1">
          <input data-v-a3842dac="" placeholder="请输入开户行" v-model="bankBox.bank_address" type="text" maxlength="20" class="amount-input" />
        </div>

        <div data-v-a3842dac="" class="deposit-title">金额</div>
        <div data-v-a3842dac="" class="amount-wrap">
          <input data-v-a3842dac="" :placeholder="`请输入取款金额 ${min_price} - ${max_price}`" v-model="amount" type="text" maxlength="17" class="amount-input" />
          <div data-v-a3842dac="" class="amount-unit">CNY</div>
        </div>
        <div data-v-a3842dac="" class="wxsm-tips">
          <i data-v-a3842dac=""></i>
          <div data-v-a3842dac="">温馨提示：选择此方式存款需于规定时间内完成，超时则无法到账，如有疑问请联系客服 <span data-v-a3842dac="" @click="$parent.openKefu()">联系客服</span></div>
        </div>
        <div data-v-a3842dac="" class="low-special-btn" @click="chongBi">确定</div>
        <div style="height: 50px"></div>
        <div data-v-a3842dac="" class="how2use" style="display: none">如何使用？</div>
      </div>
      <div data-v-5742baa6="" data-v-71669d2d="" class="dialog" v-if="wpShow">
        <div data-v-5742baa6="" class="dialog-cover back"></div>
        <div data-v-5742baa6="" class="dialog-content">
          <div data-v-71669d2d="" class="side">
            <div data-v-71669d2d="" class="side__header">
              <span data-v-71669d2d="">{{ payInfo.info.paytype }}</span
              ><a data-v-71669d2d="" href="javascript:void 0;" class="side__close" @click="closeUstShow"></a>
            </div>
            <div data-v-71669d2d="" class="side__content">
              <div data-v-71669d2d="" class="gold">
                <img data-v-71669d2d="" :src="payInfo.cardlist.payimg" alt="" class="gold__img" />
                <div data-v-71669d2d="" class="gold__amount">
                  <span data-v-71669d2d=""> 存款金额 </span><span data-v-71669d2d="" class="gold__amount-number">{{ payInfo.info.amount }}</span>
                </div>
                <p data-v-71669d2d="" class="scan__title">
                  请使用 <span data-v-71669d2d="" class="c-yellow">{{ payInfo.info.paytype }}</span
                  >完成付款
                </p>
                <p data-v-71669d2d="" class="scan__subtitle">可先截屏保存至相册，再使用{{ payInfo.info.paytype }}转账</p>
                <!-- <div data-v-71669d2d="" id="goldQr" class="scan__qr"></div> -->

                <button data-v-71669d2d="" class="scan__button" @click="closeUstShow1">已完成支付</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div data-v-5742baa6="" data-v-a3842dac="" class="dialog">
        <div data-v-5742baa6="" class="dialog-cover back" style="display: none"></div>
        <div data-v-5742baa6="" class="dialog-content" style="display: none">
          <div data-v-a3842dac="" class="paymentBox">
            <div data-v-a3842dac="" class="toolbar"><span data-v-a3842dac="" class="close"></span></div>
            <div data-v-a3842dac="" class="box">
              <div data-v-a3842dac="" class="bordered-item">
                <div data-v-a3842dac="" class="pay-method"><span data-v-a3842dac="" class="icon icon-alipay"></span> 支付宝扫码</div>
                <span data-v-a3842dac="" class="switch">切换</span>
              </div>
              <div data-v-a3842dac="" class="group">
                <p data-v-a3842dac="">金额</p>

                <div data-v-a3842dac="" class="form-holder">
                  <div data-v-a3842dac="" class="form-group">
                    <input data-v-a3842dac="" type="text" :placeholder="`请输入取款金额 ${min_price} - ${max_price}`" />
                  </div>
                </div>
                <a data-v-a3842dac="" class="btn disabled">确定</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div data-v-5742baa6="" data-v-a3842dac="" class="dialog">
        <div data-v-5742baa6="" class="dialog-cover back" style="display: none"></div>
        <div data-v-5742baa6="" class="dialog-content" style="display: none">
          <div data-v-a3842dac="" class="paymentBox">
            <div data-v-a3842dac="" class="toolbar"><span data-v-a3842dac="" class="back"></span> 选择支付方式</div>
            <div data-v-a3842dac="" class="box">
              <div data-v-a3842dac="" class="item active">
                <div data-v-a3842dac="" class="info"><span data-v-a3842dac="" class="icon icon-alipay"></span> 支付宝扫码</div>
                <div data-v-a3842dac="" class="text"><span data-v-a3842dac="" class="icon-success"></span></div>
              </div>
              <div data-v-a3842dac="" class="item">
                <div data-v-a3842dac="" class="info"><span data-v-a3842dac="" class="icon icon-alipay"></span> 支付宝支付</div>
                <div data-v-a3842dac="" class="text"><span data-v-a3842dac="" class="icon-success"></span></div>
              </div>
              <div data-v-a3842dac="" class="item">
                <div data-v-a3842dac="" class="info"><span data-v-a3842dac="" class="icon icon-wechat"></span> 微信支付</div>
                <div data-v-a3842dac="" class="text"><span data-v-a3842dac="" class="icon-success"></span></div>
              </div>
              <div data-v-a3842dac="" class="item">
                <div data-v-a3842dac="" class="info"><span data-v-a3842dac="" class="icon icon-unionpay"></span> 银联支付</div>
                <div data-v-a3842dac="" class="text"><span data-v-a3842dac="" class="icon-success"></span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div data-v-5742baa6="" data-v-a3842dac="" class="dialog">
        <div data-v-5742baa6="" class="dialog-cover back" style="display: none"></div>
        <div data-v-5742baa6="" class="dialog-content" style="display: none">
          <div data-v-a3842dac="" class="paymentBox">
            <div data-v-a3842dac="" class="toolbar"><span data-v-a3842dac="" class="back"></span> 选择支付银行</div>
            <div data-v-a3842dac="" class="box"></div>
          </div>
        </div>
      </div>
      <div data-v-15ef9544="" data-v-a3842dac="" class="dialog"></div>
      <div data-v-15ef9544="" data-v-a3842dac="" class="dialog"></div>

      <div data-v-7c9e406b="" data-v-a3842dac="" class="mint-popup" style="display: none; border-radius: 8px; width: 315px">
        <div data-v-7c9e406b="" class="content register">
          <div data-v-7c9e406b="" class="flex-center header">
            <div data-v-7c9e406b="" class="title">完善信息</div>
            <div data-v-7c9e406b="" class="close-item"><span data-v-7c9e406b="" class="close"></span></div>
          </div>
          <div data-v-7c9e406b="" class="subtitle">
            <img
              data-v-7c9e406b=""
              src="data:image/png;base64,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"
            />
            存款前，请您完成以下信息验证，感谢您的配合理解
          </div>
          <div data-v-7c9e406b="" class="register-form">
            <div data-v-7c9e406b="" class="login-group">
              <div data-v-7c9e406b="" class="login-input">
                <img
                  data-v-7c9e406b=""
                  src="data:image/png;base64,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"
                />
                <input data-v-7c9e406b="" type="text" placeholder="请输您的真实姓名" maxlength="12" class="inpt username" />
              </div>
            </div>
            <div data-v-7c9e406b="" class="login-group">
              <div data-v-7c9e406b="" class="login-input">
                <img data-v-7c9e406b="" src="image/icon-phone.cb7ce300.png" />
                <input data-v-7c9e406b="" type="text" placeholder="请输入您的手机号" maxlength="12" class="inpt username" />
              </div>
            </div>
            <div data-v-7c9e406b="" class="login-group verifyWarp">
              <div data-v-7c9e406b="" class="login-input">
                <img
                  data-v-7c9e406b=""
                  src="data:image/png;base64,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"
                />
                <input data-v-7c9e406b="" type="text" placeholder="请输入短信验证码" maxlength="6" class="inpt code" />
                <div data-v-75833532="" data-v-7c9e406b="" class="count-down disabled">
                  <div data-v-75833532="" class="send">获取验证码</div>
                </div>
              </div>
            </div>
          </div>
          <div data-v-7c9e406b="" class="flex-center okBTN">确定</div>
        </div>
      </div>
    </div>
    <!-- 没有绑定卡片 -->
    <div v-if="userbank.length == 0 && userUSD.length == 0" style="position: fixed; top: 0; left: 0; z-index: 999; width: 100vw; height: 100vh; background: rgb(0 0 0 / 66%)" data-v-a691d594="" data-v-710c460e="" data-v-29c11a50="" class="popup-background">
      <div data-v-a691d594="" data-v-29c11a50="" data-v-710c460e="" class="safety-tip">
        <i data-v-a691d594="" data-v-29c11a50="" data-v-710c460e="" class="close" @click="$router.back()"></i>
        <div data-v-a691d594="" data-v-29c11a50="" data-v-710c460e="" class="title">温馨提示</div>
        <div data-v-a691d594="" data-v-29c11a50="" data-v-710c460e="" class="unbind-box">
          您还为绑定任何钱包卡片，请前往绑定！
          <div @click="$parent.goNav('/bankCard')" style="box-sizing: border-box; width: 100%; height: 45px; margin-top: 40px; font-size: 18px; line-height: 45px; color: #fff; text-align: center; background-color: #cca352; border: none; border-radius: 4px; outline: none">前往绑定</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'deposit',
  data() {
    return {
      tab: 1,
      meyXi: 'TRC20',
      amount: null,
      pay_way: null,
      payInfo: {},
      ustShow: false,
      wpShow: false,
      xieshow: false,
      baseURL: '',
      cardLis: [],
      banklist: [],
      bankBox: {},
      payWayList: {},
      userbank: [],
      userUSD: [1],
      min_price: 100,
      max_price: 10000,
    };
  },
  created() {
    let that = this;

    that.getPayWay();
    that.getBanklist();
    that.getcard();
    that.baseURL = sessionStorage.getItem('baseURL') || '';
  },
  methods: {
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    getPayRange() {
      let that = this;
      let type = null;
      // let pay_way_arr = ['usdt', 'card', 'alipay', 'wxpay']; //

      if (that.pay_way == 1) {
        type = 'bank';
      }
      if (that.pay_way == 4) {
        type = 'wechat';
      }
      if (that.pay_way == 2) {
        type = 'alipay';
      }

      if (that.pay_way == 0) {
        if (that.meyXi == 'ERC20') {
          type = 'usdt-erc20';
        }
        if (that.meyXi == 'TRC20') {
          type = 'usdt-trc20';
        }
      }
      // bank/wechat/alipay/usdt-erc20/usdt-trc20/ebpay    min_price max_price
      that.showLoading();

      that.$apiFun
        .post('/api/getPayRange', { type })
        .then(res => {
          if (res.code == 200) {
            that.min_price = res.data.min_price;
            that.max_price = res.data.max_price;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    getuseCardlist() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 1 }).then(res => {
        if (res.code == 200) {
          that.userbank = res.data;
        }
      });
      that.$apiFun.post('/api/getcard', { type: 2 }).then(res => {
        if (res.code == 200) {
          that.userUSD = res.data;
        }
      });
    },
    getPayWay() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun
        .get('/api/get_pay_way', {})
        .then(res => {
          if (res.code == 200) {
            that.payWayList = res.data;
            let obj = that.payWayList;
            let pay_way_arr = ['usdt', 'card', 'alipay', 'wxpay']; //

            for (let i in obj) {
              if (obj[i] == 1) {
                that.pay_way = pay_way_arr.indexOf(i);
                that.tab = i == 'usdt' ? 0 : 1;
                that.$parent.hideLoading();
                that.getPayRange();
                return;
              }
            }
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getBanklist() {
      let that = this;
      that.$apiFun
        .post('/api/banklist', {})
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.banklist = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getcard() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/getpaybank', {})
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.cardLis = res.data;

            that.$parent.hideLoading();
          }
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    openXie() {
      this.xieshow = !this.xieshow;
    },
    closeUstShow() {
      this.ustShow = false;
      this.wpShow = false;
      this.payInfo = {};
    },
    closeUstShow1() {
      this.ustShow = false;
      this.wpShow = false;
      this.payInfo = {};
      this.$parent.goNav('/assets');
    },
    changTab(val) {
      let that = this;
      if (that.tab == val) {
        return;
      }
      if (val == 0) {
        that.pay_way = 0;
      } else {
        let obj = that.payWayList;
        let pay_way_arr = ['usdt', 'card', 'alipay', 'wxpay']; //
        for (let i in obj) {
          if (obj[i] == 1 && obj[i] != 'usdt') {
            that.pay_way = pay_way_arr.indexOf(i);
          }
        }
      }
      that.tab = val;
      that.amount = null;
      that.getPayRange();
    },
    // 钱包协议的选择
    changMeyXi(val) {
      let that = this;
      if (this.meyXi == val) {
        return;
      }
      this.meyXi = val;
      that.getPayRange();
    },
    chongBi() {
      let that = this;
      // 虚拟币充值  bank/alipay/wxpay/usdt
      let pay_way_arr = ['usdt', 'bank', 'alipay', 'wxpay'];
      let info = {};

      // bank 情况下  bank  bank_address  bank_no  bank_owner
      if (pay_way_arr[that.pay_way] == 'bank') {
        info = {
          paytype: pay_way_arr[that.pay_way],
          amount: that.amount * 1,
          bank: that.bankBox.bank,
          bank_address: that.bankBox.bank_address,
          bank_no: that.bankBox.bank_no,
          bank_owner: that.bankBox.bank_owner,
        };
        console.log(info);
        // 银行卡信息内容的限制
        if (!info.bank_owner) {
          that.$parent.showTost(0, '请输入存款人姓名');
          return;
        }
        if (!info.bank) {
          that.$parent.showTost(0, '请输入银行类型');
          return;
        }

        if (!info.bank_no) {
          that.$parent.showTost(0, '请输入银行卡号');
          return;
        }
        if (!info.bank_address) {
          that.$parent.showTost(0, '请输入银行开户行地址');
          return;
        }
      } else {
        //暂时
        info = {
          paytype: pay_way_arr[that.pay_way],
          amount: that.amount * 1,
        };
      }

      // 支付的金额判断
      if (info.amount < that.min_price || info.amount > that.max_price) {
        that.$parent.showTost(0, `请输入金额在${that.min_price}-${that.max_price}之间！`);
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/recharge', info)
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.amount = null;
            if (pay_way_arr[that.pay_way] == 'bank') {
              //银行充值
              that.bankBox = {};
              that.amount = null;
              that.$parent.hideLoading();
              that.$parent.showTost(1, '操作成功，等待工作人员审核！');

              setTimeout(() => {
                that.$parent.goNav('/assets');
              }, 1500);
              return;
            } //支付宝 和 微信充值
            that.bankBox = {};
            that.amount = null;
            that.getpayinfo(res.message, 1);
          }
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    usdtchongBi() {
      let that = this;
      let info = {
        amount: that.amount,
        paytype: 'usdt',
        catepay: that.meyXi,
      };
      // 支付的金额判断
      if (info.amount < that.min_price || info.amount > that.max_price) {
        that.$parent.showTost(0, `请输入金额在${that.min_price}-${that.max_price}之间！`);
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/recharge', info)
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.amount = null;
            that.getpayinfo(res.message, 0);
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    changPayway(val) {
      let that = this;
      if (val == that.pay_way) {
        return;
      }
      that.pay_way = val;
      that.bankBox = {};
      that.amount = null;
      that.getPayRange();
    },
    getpayinfo(deposit_no, type) {
      let that = this;
      that.$apiFun.post('/api/payinfo', { deposit_no }).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.payInfo = res.data;
          if (type == 0) {
            //虚拟货币显示
            that.ustShow = true;
          } else {
            //微信和支付宝显示
            that.wpShow = true;
          }
        }

        that.$parent.hideLoading();
      });
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.style.position = 'fixed';
      cInput.style.bottom = '0';
      cInput.style.right = '0';

      cInput.value = msg;
      document.body.appendChild(cInput);
      // 选取文本框内容
      cInput.select();

      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('copy');

      // 复制成功后再将构造的标签 移除
      this.$parent.showTost(1, '复制成功！');
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      console.log(vm);
      let that = this;
      vm.getuseCardlist();
    });
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-7f0f3200.8064035a.css';
@import '../../../static/css/chunk-1b70332d.c584f871.css';
.JoiHTIGs {
  display: flex;
  justify-items: center;
  flex-wrap: wrap;
}
._1lgxzaTd.VnPYo1MB {
  cursor: pointer;
}

.JoiHTIGs ._3jiVkBQ9 {
  // margin-right: 20px;
  margin-bottom: 20px;
}
._1lgxzaTd {
  width: 100%;
  height: 120px;
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 8px;
  padding: 12px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  background-image: url(/static/image/bg2.c14d2591.png);
}
.bottom-slide-enter-active[data-v-5742baa6],
.bottom-slide-leave-active[data-v-5742baa6] {
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
}
.bottom-slide-enter[data-v-5742baa6],
.bottom-slide-leave-to[data-v-5742baa6] {
  -webkit-transform: translateY(100%);
  transform: translateY(100%);
}
.dialog-content[data-v-5742baa6] {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9950;
  width: 100%;
  height: auto;
}
.dialog-cover[data-v-5742baa6] {
  z-index: 9940;
}
.authorization[data-v-2b97710c],
.dialog-cover[data-v-5742baa6] {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.authorization[data-v-2b97710c] {
  z-index: 999999;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.authorization .content[data-v-2b97710c] {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  border-radius: 8px;
  background: #fff;
  width: 315px;
}
.authorization .content .close[data-v-2b97710c] {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 15px;
  right: 15px;
  margin: auto;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAAEEfUpiAAAABGdBTUEAALGPC/xhBQAAAh5JREFUWAm1lYlxwjAQRTE0xEAVSbogKStJF5k0gQ0NgbN/46/RsbpM4hmQvMfbr5Vlb+Z5HjbxdT6fZ9g4qt+8CYwIC3iNN4qXvwS28BI7DGD7ji0pLDoMgy6CdpXmZziHTNR+uVyefaM/V984jh/4+Q7MqUftcZDvdK0mRcSejsfjNhFLLAMVLX9umcAiE444KBS0BDBIu2bVdAFY6+12+xJRnxL4ihK1C10XwD2IAxE6SQ6cyw330W9TEmeBSomuzzEJIPScdqsP8Lk2MxAjKjIZvYFtmqZ3jMWrJNVamoOVEl3QMklA2MZiV2NCBNoAAAWZuKyZee585rpsEbhDu93uxR3Z1mUkPUCF1iaayZRYgxSTa5Cm5ByklmxuH5Yjie64lo66eRbwwuIZgLLD4fBGhfFoAiBbVJwIgRqoipPN+3jNtd0JIHEynU2QXHITpJZchLQm5yB6Gkv7zER/RE+k8B2nceB3AQEAYc9lDL+yfvYDcxTGu1VGfVmrgNj4H0KKNbigYtDKjrQwk9PRkkTRubGHkQggtAfySE5WQA90jVjyqwIYmCsCv/j0qca89yQ1CwAclyUE9t7CyMHVJSBX/Be1TkSTAKswV4zi/ssF9/TJWH2hFQWUCsfwnliI5GUKWAsDtDc3ENCbzFVYYytLBbQGW4Vqtho7+BoC1vMA1Yr7fkuI+xper9cnBO/3++/44fIhfzGHEL/eD8H/cjgqcbjmAAAAAElFTkSuQmCC)
    no-repeat;
  background-size: 100% 100%;
}
.authorization .content .content-box[data-v-2b97710c] {
  padding: 40px 20px 20px;
}
.authorization .content .content-box .kyberbit[data-v-2b97710c] {
  height: 50px;
}
.authorization .content .content-box h3[data-v-2b97710c] {
  color: #333;
  font-size: 18px;
  margin-top: 3px;
  margin-bottom: 2px;
}
.authorization .content .content-box p[data-v-2b97710c] {
  color: #666;
  margin-top: 4px;
}
.authorization .content .content-box .logo-box[data-v-2b97710c] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-top: 16px;
  background: #eef0f5;
  padding: 15px;
  border-radius: 4px;
}
.authorization .content .content-box .logo-box img[data-v-2b97710c] {
  display: block;
  width: 50px;
  margin-right: 10px;
}
.authorization .content .content-box .logo-box span[data-v-2b97710c] {
  display: block;
  color: #333;
  margin-top: 5px;
}
.authorization .content .btn-box[data-v-2b97710c] {
  margin-top: 15px;
}
.authorization .content .btn-box .btn[data-v-2b97710c] {
  border-radius: 4px;
  color: #cca352;
  height: 45px;
  line-height: 45px;
  text-align: center;
}
.authorization .content .btn-box .btn.active[data-v-2b97710c] {
  background: #cca352;
  color: #fff;
}
.differentDepositTip[data-v-74a3466c] {
  width: 100%;
  padding: 0 0.13rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-image: -webkit-gradient(linear, left top, right top, from(#fa471d), color-stop(52%, #8900d3), to(#60f));
  background-image: linear-gradient(90deg, #fa471d, #8900d3 52%, #60f);
}
.differentDepositTip .item[data-v-74a3466c] {
  width: 100%;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  height: 0.35rem;
}
.differentDepositTip .item .item-left[data-v-74a3466c],
.differentDepositTip .item[data-v-74a3466c] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.differentDepositTip .item .item-left[data-v-74a3466c] {
  font-size: 0.13rem;
  color: #fff;
  font-weight: 500;
}
.differentDepositTip .item .item-left img[data-v-74a3466c] {
  width: 0.16rem;
  height: 0.16rem;
}
.differentDepositTip .item .item-left span[data-v-74a3466c] {
  margin-left: 0.05rem;
}
.differentDepositTip .item .item-right[data-v-74a3466c] {
  font-size: 0.13rem;
  color: #fff;
  font-weight: 400;
  border: 1px solid #fff;
  border-radius: 4px;
  width: 0.6rem;
  height: 0.22rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.differentDepositTip .item .item-right img[data-v-74a3466c] {
  margin-left: 0.02rem;
  display: block;
  margin-top: 0.03rem;
}
.differentDepositTip.depositBottom[data-v-74a3466c] {
  background: #212121;
  border-radius: 0.04rem;
  margin-top: 0.1rem;
}
.differentDepositTip.depositBottom .item[data-v-74a3466c] {
  height: 0.4rem;
}
.differentDepositTip.depositBottom .item .item-left[data-v-74a3466c] {
  color: #ffcb4c;
}
.differentDepositTip.depositBottom .item .item-left img[data-v-74a3466c] {
  width: 0.26rem;
  height: 0.22rem;
  margin-top: 0.06rem;
}
.differentDepositTip.depositBottom .item .item-left span[data-v-74a3466c] {
  margin-left: 0;
}
.differentDepositTip.depositBottom .item .item-right[data-v-74a3466c] {
  border: none;
  color: #ffcb4c;
}
.differentDepositTip.depositSidBar[data-v-74a3466c] {
  background-image: -webkit-gradient(linear, left top, right top, color-stop(34%, #fa471d), to(#8b1ae5));
  background-image: linear-gradient(90deg, #fa471d 34%, #8b1ae5);
}
.protocolPopUp[data-v-26c8fc86] {
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
.protocolPopUp .title[data-v-26c8fc86],
.protocolPopUp[data-v-26c8fc86] {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background: #fff;
}
.protocolPopUp .title[data-v-26c8fc86] {
  height: 0.4rem;
  font-size: 16px;
  color: #333 !important;
  font-weight: 600;
}
.protocolPopUp .title .close[data-v-26c8fc86] {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAAEgBckRAAAAAXNSR0IArs4c6QAAA6lJREFUaAXNWbtyFDEQvLXhUyD341dMQGQHRPA5OCKAiID7FduXw6eA65hWbcvSrB6jB3Vc1dVIo5nuaUmr3b3b7Uqfh4eHYzge9dmhDQN3RWc0GHUEQ/c97OFweLM7Ho+v8KVXon+w7QcjJ0fhDDOdn5ERLJ3M1IPSfymAQaEFgHxfpg4JcOhEHbiEKGgj4fHx8bc09/K9ub6+jmLOEBR+JPg7+ldXV+9hNSN87qOp6UdCVCqmHQ4G5CwTd26dclEJ/0J0LU7HIm5Zlm/Ojw4TdSD66/jL5gicGy3JYKJqplRwtChkIoDYvWh7F/TTTc0URm1WGsFARtDaDuPjtq65xJSeupVlw6SRY16/Dm7KudLV2SDLgr30/Pz8E6iypV/L8v/RDK19AceuuEGeW7fgInNYvUQhsAA5ldHG6CVKAbtKqYAdWitRCZhYkQI6aXNEFmBiFAkYpIlWf3UnIW5z6RA0tDw4Q5+0b0CsfJtuUUFuKrSi0q5LEuSAdXkWoojACtxC5Ah6gU1ECBICd4eQubzTST19Tp0cO/cuv/XeZiElJk9H5Jj2dQ2c1SPu/Pz87Zm/ecq+XteihpEdD8ERdHFx8WvaImtwXht+m47spBw4VHgCdHpISuAbglaSGniSwEpiAc8S1Eis4EWCHEkLeJUgRSI+97SAMW5FtHOfaBflgtTucmEWcASa7mgC5l4BggL21uenqgI95yGJ5Vm3qECDY1qEwD3qijWdXVkFKXBOi1qT4imcJCiBc4qsJBsCC3gLSUTQAm4l8QQ94BYSRzACXiNZZoCXSMKbvulsIVjOhruLN3337GI9W3LA9OPq5oOEv+nL0/NnmaqPCMLg5eXlB15UTDy1xVI+PT19EXuLWqS+e5mUT9FLpipyj0P01ELWPYjfdfxtiHViicOrIBkkwScRUio8rMmfE1BlTULsv/q01hAJYFGtIMwbsb2cSQEspBeU+RY7ylEUwAJGSYgT2lmYJgEknkE6A4P1wDYJYGJPET055CvZLgEEtBSF2PVnps05LkPDR/SQAKMQhoV2uHCCTRFAsMqKIGxa4eScJsBQPDmnihgWUCncv8Kx+sBOEdItoFZ4+CDYEhsINDWbBYwUM5KbU2MWMJN8JlZVwEwyPYszsLMCZoDrgnP9Ea6NgBGwXIFWfw+3F9CTbC2sNa6lFidAnlW+StJtgmjKWZ3ANblKQvDjgxzVd7mX+pMWrtXlhOCl3sfi7yH+ReSd/2FD1/kXqyYUaF3HgagAAAAASUVORK5CYII=)
    no-repeat;
  background-size: 100% 100%;
  width: 0.12rem;
  height: 0.12rem;
  position: absolute;
  top: 0.15rem;
  right: 0.15rem;
}
.protocolPopUp .content[data-v-26c8fc86] {
  overflow: hidden;
  width: 100%;
  height: calc(100% - 0.4rem);
  overflow-y: auto;
}
.protocolPopUp .content img[data-v-26c8fc86] {
  max-width: 100%;
  height: auto;
  margin-top: 0.1rem;
}
.scan__qr img {
  width: 100%;
  height: 100%;
}
.mt125[data-v-71669d2d] {
  margin-top: 125px !important;
}
.c-yellow[data-v-71669d2d] {
  color: #cca352;
}
.protocol-box .sub-tips[data-v-71669d2d] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin: 0.2rem 0 0.1rem 0;
  font-size: 0.16rem;
  color: #fff;
}
.protocol-box .sub-tips img[data-v-71669d2d] {
  width: 0.14rem;
  height: 0.14rem;
  margin-left: 0.03rem;
}
.protocol-box .dcbox-protocol[data-v-71669d2d] {
  height: 45px;
  background: #282828;
  border-radius: 4px;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 0 0.55rem;
  margin-bottom: 0.15rem;
}
.protocol-box .dcbox-protocol .protocol-item[data-v-71669d2d],
.protocol-box .dcbox-protocol[data-v-71669d2d] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.protocol-box .dcbox-protocol .protocol-item .text[data-v-71669d2d] {
  font-size: 14px;
  color: #999;
  font-weight: 400;
}
.protocol-box .dcbox-protocol .protocol-item .circle[data-v-71669d2d] {
  width: 12px;
  height: 12px;
  border: 1px solid #999;
  border-radius: 50%;
  margin-right: 7px;
  position: relative;
}
.protocol-box .dcbox-protocol .protocol-item img[data-v-71669d2d] {
  width: 0.3rem;
  height: 0.16rem;
  margin-left: 0.05rem;
}
.protocol-box .dcbox-protocol .protocol-item.active .text[data-v-71669d2d] {
  font-size: 14px;
  color: #fff;
}
.protocol-box .dcbox-protocol .protocol-item.active .circle[data-v-71669d2d] {
  border: 1px solid #facb5c;
}
.protocol-box .dcbox-protocol .protocol-item.active .circle[data-v-71669d2d]:after {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #facb5c;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
}
.deposit .deposit-input-title[data-v-71669d2d] {
  margin: 20px 0 0;
  font-size: 0.16rem;
  color: #fff;
}
.deposit__amount-input-wrapper[data-v-71669d2d] {
  position: relative;
  margin-top: 0.1rem;
  width: 100%;
  height: 0.5rem;
  background: #212121;
  border-radius: 0.04rem;
}
.deposit__amount-unit[data-v-71669d2d] {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  right: 0;
  width: 0.5rem;
  height: 0.5rem;
  background: #333;
  border-radius: 4px;
  font-size: 0.16rem;
  color: #999;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.deposit__amount-input[data-v-71669d2d] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  font-size: 24px;
  line-height: 34px;
  color: #fff;
  background-color: transparent;
  border: none;
  outline: none;
  padding-left: 0.1rem;
}
.deposit__amount-input[data-v-71669d2d]::-webkit-input-placeholder {
  font-size: 16px;
  color: #666;
}
.deposit__amount-input[data-v-71669d2d]::-moz-placeholder {
  font-size: 16px;
  color: #666;
}
.deposit__amount-input[data-v-71669d2d]:-ms-input-placeholder {
  font-size: 16px;
  color: #666;
}
.deposit__amount-input[data-v-71669d2d]::-ms-input-placeholder {
  font-size: 16px;
  color: #666;
}
.deposit__amount-input[data-v-71669d2d]::placeholder {
  font-size: 16px;
  color: #666;
}
.deposit__cny-tips[data-v-71669d2d] {
  margin-top: 5px;
  font-size: 16px;
  line-height: 1;
  color: #999;
}
.deposit__content[data-v-71669d2d] {
  padding: 0 15px;
  overflow: hidden;
}
.deposit__title[data-v-71669d2d] {
  margin: 20px 0 15px;
  font-size: 16px;
  line-height: 18px;
  color: #fff;
}
.deposit__list[data-v-71669d2d] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-left: 30px;
}
.deposit__item[data-v-71669d2d] {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: inline-block;
  width: 33.33%;
  height: 80px;
  overflow: hidden;
  font-size: 14px;
  color: #fff;
  text-align: center;
  vertical-align: top;
  background-color: #333;
  border: 1px solid transparent;
  border-radius: 5px;
}
.deposit__item + .deposit__item[data-v-71669d2d] {
  margin-left: 15px;
}
.deposit__item[data-v-71669d2d]:nth-child(3n + 1) {
  margin-left: -30px;
}
.deposit__item[data-v-71669d2d]:nth-child(n + 4) {
  margin-top: 15px;
}
.deposit__item.active[data-v-71669d2d] {
  background-color: #282828;
  border: 1px solid #cca352;
}
.deposit__item.amount[data-v-71669d2d] {
  height: 50px;
  font-size: 16px;
  line-height: 50px;
  color: #ccc;
  border-radius: 4px;
}
.deposit .ylcb-tips[data-v-71669d2d] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 14px;
  background: url(/static/image/bank_tips.bb95242e.png) no-repeat;
  background-size: 100% 100%;
}
.deposit__icon[data-v-71669d2d] {
  width: 30px;
  height: 30px;
  margin-top: 15px;
  margin-bottom: 5px;
  vertical-align: top;
}
.deposit__button[data-v-71669d2d] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 45px;
  margin-top: 40px;
  font-size: 18px;
  line-height: 45px;
  color: #fff;
  text-align: center;
  background-color: #cca352;
  border: none;
  border-radius: 4px;
  outline: none;
}
.side[data-v-71669d2d] {
  background-color: #fff;
  border-radius: 4px 4px 0 0;
}
.side__header[data-v-71669d2d] {
  position: relative;
  height: 48px;
  font-size: 18px;
  line-height: 48px;
  color: #333;
  text-align: center;
  border-bottom: 1px solid #f4f4f4;
}
.side__close[data-v-71669d2d] {
  position: absolute;
  top: 50%;
  right: 15px;
  width: 14px;
  height: 14px;
  margin-top: -7px;
  background: url(data:image/png;base64,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)
    no-repeat 50%;
}
.side__content[data-v-71669d2d] {
  min-height: 200px;
  max-height: 580px;
  padding: 0 15px;
  overflow: auto;
}
.gold[data-v-71669d2d],
.scan[data-v-71669d2d] {
  padding-bottom: 15px;
}
.gold__amount[data-v-71669d2d],
.scan__amount[data-v-71669d2d] {
  height: 54px;
  font-size: 16px;
  line-height: 54px;
  color: #666;
  border-bottom: 1px solid #ddd;
}
.gold__amount-number[data-v-71669d2d],
.scan__amount-number[data-v-71669d2d] {
  float: right;
  color: #333;
}
.gold__title[data-v-71669d2d],
.scan__title[data-v-71669d2d] {
  margin-top: 15px;
  font-size: 15px;
  line-height: 21px;
  color: #333;
  text-align: center;
}
.gold__subtitle[data-v-71669d2d],
.scan__subtitle[data-v-71669d2d] {
  font-size: 13px;
  line-height: 18px;
  color: #999;
  text-align: center;
}
.gold__crc[data-v-71669d2d],
.scan__crc[data-v-71669d2d] {
  font-size: 12px;
  color: #999;
  text-align: center;
  margin-bottom: -8px;
  margin-top: 5px;
}
.gold__qrwrap[data-v-71669d2d],
.scan__qrwrap[data-v-71669d2d] {
  position: absolute;
  width: 150px;
  height: 150px;
  margin-top: 15px;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
.gold__qrwrap .crc2[data-v-71669d2d],
.scan__qrwrap .crc2[data-v-71669d2d] {
  position: absolute;
  opacity: 0.3;
  background: #000;
  right: 0;
  bottom: 9px;
  color: #fff;
  z-index: 2;
  font-size: 12px;
  padding: 2px 1px;
}
.gold__qr[data-v-71669d2d],
.scan__qr[data-v-71669d2d] {
  width: 150px;
  height: 150px;
  margin: 15px auto;
  font-size: 0;
}
.gold__qr img[data-v-71669d2d],
.scan__qr img[data-v-71669d2d] {
  width: 130px;
  height: 130px;
}
.gold__protocol[data-v-71669d2d],
.scan__protocol[data-v-71669d2d] {
  width: 1.5rem;
  height: 0.24rem;
  line-height: 0.24rem;
  background: #000;
  border-radius: 0.12rem;
  margin: 0 auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  color: #fff;
  letter-spacing: 0;
  font-weight: 500;
  font-size: 0.14rem;
  padding: 0 0.1rem;
}
.gold__protocol .ex-change[data-v-71669d2d],
.scan__protocol .ex-change[data-v-71669d2d] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #ffcb4c;
  font-weight: 400;
  margin-left: 0.05rem;
}
.gold__protocol .ex-change img[data-v-71669d2d],
.scan__protocol .ex-change img[data-v-71669d2d] {
  width: 0.12rem;
  height: 0.12rem;
  margin-left: 0.03rem;
}
.gold .small-gold[data-v-71669d2d],
.scan .small-gold[data-v-71669d2d] {
  margin-top: -0.1rem;
}
.gold .tip-list[data-v-71669d2d],
.scan .tip-list[data-v-71669d2d] {
  font-size: 0.12rem;
  color: #999;
  font-weight: 500;
  margin-top: 0.15rem;
}
.gold .tip-list span[data-v-71669d2d],
.scan .tip-list span[data-v-71669d2d] {
  color: #cca452;
}
.gold__link[data-v-71669d2d],
.scan__link[data-v-71669d2d] {
  position: relative;
  height: 35px;
  padding-right: 70px;
  margin-top: 5px;
  overflow: hidden;
  font-size: 14px;
  line-height: 35px;
  color: #333;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: #f5f5f5;
  border-radius: 4px;
}
.gold__copy[data-v-71669d2d],
.scan__copy[data-v-71669d2d] {
  position: absolute;
  top: 0;
  right: 0;
  width: 70px;
  height: 100%;
  color: #fff;
  text-align: center;
  background-color: #cca352;
  border-radius: 4px;
}
.gold__tips[data-v-71669d2d],
.scan__tips[data-v-71669d2d] {
  margin-top: 15px;
  font-size: 12px;
  line-height: 17px;
  color: #999;
}
.gold__button[data-v-71669d2d],
.scan__button[data-v-71669d2d] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 48px;
  margin-top: 20px;
  font-size: 18px;
  line-height: 48px;
  color: #fff;
  text-align: center;
  background-color: #cca352;
  border: none;
  border-radius: 4px;
  outline: none;
}
.scan[data-v-71669d2d] {
  position: relative;
}
.gold__img[data-v-71669d2d] {
  width: 100%;
  height: auto;
  margin-top: 20px;
  vertical-align: top;
}
.exchange[data-v-71669d2d] {
  padding-bottom: 15px;
  padding-left: 15px;
}
.exchange__item[data-v-71669d2d] {
  position: relative;
  display: inline-block;
  width: 50%;
  margin-top: 15px;
  overflow: hidden;
  text-align: center;
  vertical-align: top;
  background-color: #f5f5f5;
  border-radius: 6px;
}
.exchange__item[data-v-71669d2d]:nth-child(odd) {
  margin-right: 15px;
  margin-left: -15px;
}
.exchange__item .logo-link[data-v-71669d2d] {
  display: inline-block;
  width: 100%;
}
.exchange__icon[data-v-71669d2d] {
  width: 100%;
  height: 115px;
  vertical-align: top;
}
.exchange__link[data-v-71669d2d] {
  height: 36px;
  font-size: 14px;
  line-height: 36px;
  color: #333;
  background-color: #eee;
}
.exchange__icon-hot[data-v-71669d2d] {
  position: absolute;
  top: 0;
  right: 0;
  width: 48px;
  height: 24px;
  font-size: 14px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  background: -webkit-gradient(linear, left top, right top, from(#2ee6c7), to(#4d88ff));
  background: linear-gradient(90deg, #2ee6c7, #4d88ff);
  border-radius: 0 6px 0 6px;
}
.banner-wrap[data-v-71669d2d] {
  width: 100%;
  position: absolute;
  bottom: 20px;
  padding: 0 15px;
}
.banner-wrap .page__banner[data-v-71669d2d] {
  position: relative;
}
.banner-wrap .page__banner-img[data-v-71669d2d] {
  width: 100%;
  height: auto;
  vertical-align: top;
}
.banner-wrap .page__text-button-guide[data-v-71669d2d] {
  z-index: 2;
  position: absolute;
  width: 88px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  color: #fff;
  border: 1px solid #fff;
  left: 50%;
  top: 34px;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
  border-radius: 15px;
}
.banner-wrap .page__text-button-reg[data-v-71669d2d] {
  position: absolute;
  left: 0;
  width: 40%;
  height: 100%;
}
.banner-wrap .page__text-button-reg .btn[data-v-71669d2d] {
  position: absolute;
  color: #fff;
  left: 20px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.banner-wrap .page__text-button-download[data-v-71669d2d] {
  position: absolute;
  right: 0;
  width: 40%;
  height: 100%;
}
.banner-wrap .page__text-button-download .btn[data-v-71669d2d] {
  position: absolute;
  color: #fff;
  right: 20px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.banner-wrap .page__full-tips[data-v-71669d2d] {
  height: 20px;
  font-size: 14px;
  line-height: 20px;
  color: #666;
  text-align: center;
}
.no-data-notice[data-v-71669d2d] {
  margin-top: 60px;
  text-align: center;
}
.guide[data-v-71669d2d] {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.8);
}
.guide__button[data-v-71669d2d] {
  position: absolute;
  left: 50%;
  bottom: 100px;
  width: 162px;
  padding: 5px 0;
  margin-left: -81px;
  font-size: 14px;
  color: #cca352;
  text-align: center;
  background-color: #000;
  border: 1px solid #996b3d;
  border-radius: 4px;
  outline: none;
}
.guide__title[data-v-71669d2d] {
  margin-top: 75px;
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
  color: #f3b663;
  text-align: center;
}
.guide__subtitle[data-v-71669d2d] {
  margin-top: 18px;
  font-size: 15px;
  line-height: 1;
  color: #fff;
  text-align: center;
}
.guide__subtitle + .guide__subtitle[data-v-71669d2d] {
  margin-top: 10px;
}
.guide__img[data-v-71669d2d] {
  width: 100%;
  height: auto;
}
.guide__cny-img[data-v-71669d2d] {
  width: 252px;
  height: auto;
  margin-top: 16px;
}
.guide__usdt-img[data-v-71669d2d] {
  width: 278px;
  height: auto;
  margin-top: 48px;
}
.guide__usdt-img.img1[data-v-71669d2d] {
  margin-top: 70px;
}
.guide__close[data-v-71669d2d] {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 20px;
  height: 20px;
}
.guide__cny-arrow[data-v-71669d2d] {
  position: absolute;
  bottom: 90px;
  left: 40px;
  width: auto;
  height: 150px;
}
.guide__usdt-arrow[data-v-71669d2d] {
  position: absolute;
  top: 42px;
  left: 76px;
  width: 35px;
  height: auto;
}
.guide__usdt-arrow1[data-v-71669d2d] {
  position: absolute;
  top: 128px;
  left: 76px;
  width: 78px;
  height: auto;
}
.kyberbit-guide-button[data-v-71669d2d] {
  position: fixed;
  right: 10px;
  bottom: 92px;
  z-index: 10;
  width: 50px;
  height: 50px;
  background-image: url(/static/image/btn-entrance.36d47e44.png);
  background-size: 100% 100%;
}
.showPopupTxt[data-v-71669d2d] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #cca352;
  text-decoration: underline;
  margin-top: 20px;
}
.protocolPopUp .title[data-v-26c8fc86][data-v-1b127c58] {
  height: 1.4rem;
  font-size: 16px;
  color: #333 !important;
  font-weight: 600;
}
.protocolPopUp .title .close[data-v-26c8fc86][data-v-1b127c58] {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAAEgBckRAAAAAXNSR0IArs4c6QAAA6lJREFUaAXNWbtyFDEQvLXhUyD341dMQGQHRPA5OCKAiID7FduXw6eA65hWbcvSrB6jB3Vc1dVIo5nuaUmr3b3b7Uqfh4eHYzge9dmhDQN3RWc0GHUEQ/c97OFweLM7Ho+v8KVXon+w7QcjJ0fhDDOdn5ERLJ3M1IPSfymAQaEFgHxfpg4JcOhEHbiEKGgj4fHx8bc09/K9ub6+jmLOEBR+JPg7+ldXV+9hNSN87qOp6UdCVCqmHQ4G5CwTd26dclEJ/0J0LU7HIm5Zlm/Ojw4TdSD66/jL5gicGy3JYKJqplRwtChkIoDYvWh7F/TTTc0URm1WGsFARtDaDuPjtq65xJSeupVlw6SRY16/Dm7KudLV2SDLgr30/Pz8E6iypV/L8v/RDK19AceuuEGeW7fgInNYvUQhsAA5ldHG6CVKAbtKqYAdWitRCZhYkQI6aXNEFmBiFAkYpIlWf3UnIW5z6RA0tDw4Q5+0b0CsfJtuUUFuKrSi0q5LEuSAdXkWoojACtxC5Ah6gU1ECBICd4eQubzTST19Tp0cO/cuv/XeZiElJk9H5Jj2dQ2c1SPu/Pz87Zm/ecq+XteihpEdD8ERdHFx8WvaImtwXht+m47spBw4VHgCdHpISuAbglaSGniSwEpiAc8S1Eis4EWCHEkLeJUgRSI+97SAMW5FtHOfaBflgtTucmEWcASa7mgC5l4BggL21uenqgI95yGJ5Vm3qECDY1qEwD3qijWdXVkFKXBOi1qT4imcJCiBc4qsJBsCC3gLSUTQAm4l8QQ94BYSRzACXiNZZoCXSMKbvulsIVjOhruLN3337GI9W3LA9OPq5oOEv+nL0/NnmaqPCMLg5eXlB15UTDy1xVI+PT19EXuLWqS+e5mUT9FLpipyj0P01ELWPYjfdfxtiHViicOrIBkkwScRUio8rMmfE1BlTULsv/q01hAJYFGtIMwbsb2cSQEspBeU+RY7ylEUwAJGSYgT2lmYJgEknkE6A4P1wDYJYGJPET055CvZLgEEtBSF2PVnps05LkPDR/SQAKMQhoV2uHCCTRFAsMqKIGxa4eScJsBQPDmnihgWUCncv8Kx+sBOEdItoFZ4+CDYEhsINDWbBYwUM5KbU2MWMJN8JlZVwEwyPYszsLMCZoDrgnP9Ea6NgBGwXIFWfw+3F9CTbC2sNa6lFidAnlW+StJtgmjKWZ3ANblKQvDjgxzVd7mX+pMWrtXlhOCl3sfi7yH+ReSd/2FD1/kXqyYUaF3HgagAAAAASUVORK5CYII=)
    no-repeat;
  background-size: 100% 100%;
  width: 0.42rem;
  height: 0.42rem;
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/main/deposit.vue